"use strict";

Drupal.behaviors.accordion = {
  attach: function attach(context) {
    // @TODO – add other selectors that leverage this script as needed.
    ['.accordion__item'].forEach(function (selector) {
      var accordions = document.querySelectorAll(selector);
      accordions.forEach(function (accordionElem) {
        if (!accordionElem.classList.contains('js-processed')) {
          Drupal.behaviors.accordion.initAccordion(accordionElem);
          accordionElem.classList.add('js-processed');
        }
      });
    });
  },
  initAccordion: function initAccordion(accordionElem) {
    var accordionTrigger = accordionElem.querySelector('.accordion-trigger');
    var accordionToggle = function accordionToggle(e) {
      var accordionButton = e.target;
      var accordionWrapper = accordionButton.closest('.accordion__item');
      var accordionParent = accordionWrapper.closest('.block');
      var accordionBody = e.target.nextElementSibling;
      var openAccordion = accordionParent.querySelector('[aria-expanded="true"]');
      var accordionSpacing = window.getComputedStyle(accordionButton);

      // Close open accordions when clicking on a different one.
      if (openAccordion && e.target != openAccordion) {
        var openAccordionBody = openAccordion.nextElementSibling;
        openAccordion.setAttribute('aria-expanded', 'false');
        openAccordionBody.style.height = '0';
      }

      // Toggle accordion open/close.
      if (accordionButton.getAttribute('aria-expanded') == 'false') {
        accordionButton.setAttribute('aria-expanded', 'true');
        accordionBody.style.height = accordionBody.scrollHeight + parseInt(accordionSpacing.paddingTop) + 'px';
      } else {
        accordionButton.setAttribute('aria-expanded', 'false');
        accordionBody.style.height = '0';
      }
    };
    if (typeof accordionTrigger !== 'undefined') {
      accordionTrigger.addEventListener('click', accordionToggle);
    }
  }
};